<template>
    <div class="one-page">
        <div class="slide-pic" :class="{'slide-pic-blur':blurBg}"
             :style="'background-image: url(\''+bgPics[bgIndex]+'\')'"></div>
        <div class="content">
            <top-nav></top-nav>
            <about-us v-if="component.aboutUs"></about-us>
            <start v-if="component.btnStart"></start>
            <intro v-if="component.intro"></intro>
            <i-map v-if="component.map"></i-map>
            <left-menu v-if="component.leftMenu"></left-menu>
            <close-details></close-details>
            <content-list></content-list>
            <preview v-if="showPreview"></preview>
            <project-intro></project-intro>
            <news v-if="component.news"></news>
        </div>
    </div>
</template>

<script>
    import start from "@/components/start"
    import intro from "@/components/intro"
    import topNav from "@/components/top-nav"
    import recommend from "@/components/recommend"
    import iMap from "@/components/map"
    import leftMenu from "@/components/left-menu"
    import closeDetails from "@/components/close-details"
    import contentList from "@/components/content-list"
    import preview from "@/components/preview"
    import projectIntro from "@/components/project-intro"
    import aboutUs from "@/components/about-us"
    import news from "@/components/news"
    import {mapGetters} from 'vuex'

    export default {
        name: "index",
        components: {
            start,
            intro,
            topNav,
            recommend,
            iMap,
            leftMenu,
            closeDetails,
            preview,
            contentList,
            projectIntro,
            aboutUs,
            news
        },
        data() {
            return {
                bgPics: [],
                bgIndex: 1,
                changeBgTimer: null
            }
        },
        methods: {
            getHome: function () {
                this.$http.request('home').then(res => {
                    if (res.status === 'success') {
                        this.bgPics = res.data.bg_pics;
                        this.changeBgInterval();
                    }
                });
            },
            changeBgInterval: function () {
                let length = this.bgPics.length;
                if (!this.changeBgTimer) {
                    let _self = this;
                    this.changeBgTimer =
                        setInterval(function () {
                            if (_self.bgIndex >= length - 1) {
                                _self.bgIndex = 0;
                            } else {
                                _self.bgIndex++;
                            }
                        }, 10000)
                }
            }
        },
        created: function () {
            this.getHome();
        },
        computed: {
            ...mapGetters([
                'component', 'blurBg', 'showPreview'
            ]),
        }
    }
</script>

<style scoped lang="less">
    .one-page {
        width: 100vw;
        height: 100vh;
        min-width: 1200px;
        overflow: hidden;
        .slide-pic {
            width: 100%;
            height: 100%;
            animation: bg ease 10s infinite;
            background: center center no-repeat;
            background-size: cover;
        }
        .slide-pic-blur {
            filter: blur(8px);
        }
        .content {
            width: 100%;
            min-width: 1200px;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            padding: 0 100px;
        }
    }

    @keyframes bg {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.3);
        }
        100% {
            transform: scale(1);
        }
    }
</style>